import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="section-padding relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent" />
      <div className="container mx-auto relative z-10 text-center max-w-2xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="font-display text-3xl md:text-5xl font-bold mb-6">
            Liity <span className="text-primary">jäseneksi</span>
          </h2>
          <div className="divider-primary mx-auto mb-8" />
          <Link
            to="/hinnasto"
            className="btn-primary-premium inline-block px-10 py-4 rounded text-base"
          >
            Hinnasto
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
